export default "__VITE_ASSET__f9482aab__"